var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelocitaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3215 21.682C9.73978 22.4475 11.3325 22.8317 12.9438 22.7971C14.5551 22.7624 16.1299 22.3101 17.5139 21.4843C18.898 20.6586 20.044 19.4876 20.8398 18.0861C21.6356 16.6846 22.054 15.1006 22.054 13.4889C22.054 11.8772 21.6356 10.2931 20.8398 8.8916C20.044 7.4901 18.898 6.31919 17.5139 5.49342C16.1299 4.66766 14.5551 4.21533 12.9438 4.18068C11.3325 4.14603 9.73978 4.53026 8.3215 5.29577M1.94727 9.01991H7.16106M1.94727 17.9578H7.16106M1.94727 13.4889H4.18175M19.4507 6.78543L20.568 5.66818M12.7473 3.80612V1.19922M12.7473 1.19922H9.39554M12.7473 1.19922H16.099M16.099 10.1371L12.3749 13.8613",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelocitaIcon);
export default __webpack_public_path__ + "static/media/Velocita_icon.04b9534866e7e97e463451cd3b6c2e8b.svg";
export { ForwardRef as ReactComponent };